import { SERVICES } from "@/data/content";
import { Dumbbell, Utensils, TrendingUp, Dna, ArrowUpRight } from "lucide-react";

const ICONS = {
  Dumbbell,
  Utensils,
  TrendingUp,
  Dna,
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-ng-bg py-24 md:py-36 border-t border-ng-line hex-bg"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
          <div className="max-w-2xl">
            <div className="label-eyebrow mb-5">01 · The Method</div>
            <h2 className="font-display font-bold uppercase text-4xl md:text-6xl tracking-tight text-white leading-[0.95]">
              Four pillars.{" "}
              <span className="text-ng-blue italic">One system.</span>
            </h2>
          </div>
          <p className="text-white/65 max-w-md font-light leading-relaxed">
            Every NextGen client moves through the same proven framework &mdash;
            coaching, nutrition, results tracking and optimization. No
            guesswork. No filler.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
          {SERVICES.map((s) => (
            <ServiceCard key={s.id} service={s} />
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="font-display italic font-semibold tracking-[0.18em] uppercase text-ng-blue text-sm md:text-base">
            &ldquo;Building Better Bodies. Changing Lives.&rdquo;
          </p>
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ service }) {
  const Icon = ICONS[service.icon] || Dumbbell;
  return (
    <div
      data-testid={`service-card-${service.id}`}
      className={`group relative bg-ng-surface border border-ng-line p-8 md:p-12 hover:border-ng-blue/50 transition-all duration-500 hover:-translate-y-1 overflow-hidden ${service.span}`}
    >
      <div className="absolute top-0 left-0 w-12 h-12 border-t border-l border-ng-blue opacity-60" />
      <div className="absolute bottom-0 right-0 w-12 h-12 border-b border-r border-ng-blue opacity-60" />

      <div className="flex flex-col h-full relative z-10">
        <div className="flex items-start justify-between mb-6">
          <div className="w-14 h-14 border border-ng-blue/40 flex items-center justify-center text-ng-blue group-hover:border-ng-blue group-hover:shadow-[0_0_24px_rgba(30,144,255,0.5)] transition-all">
            <Icon size={26} strokeWidth={1.5} />
          </div>
          <ArrowUpRight
            size={20}
            strokeWidth={1.5}
            className="text-white/30 group-hover:text-ng-blue group-hover:rotate-45 transition-all duration-500"
          />
        </div>
        <h3 className="font-display font-bold uppercase text-2xl md:text-3xl text-white tracking-tight">
          {service.title}
        </h3>
        <p className="mt-1 text-ng-blue text-sm uppercase tracking-[0.18em] font-display font-semibold">
          {service.short}
        </p>
        <p className="mt-5 text-white/65 leading-relaxed font-light flex-1">
          {service.description}
        </p>
      </div>
    </div>
  );
}
